import {
  COMMERCIAL_DEAL_LIST_ERROR,
  COMMERCIAL_DEAL_LIST_RECEIVED,
  COMMERCIAL_DEAL_LIST_REQUEST,
  COMMERCIAL_DEAL_LIST_UNLOAD,
  COMMERCIAL_DEAL_SINGLE_ERROR,
  COMMERCIAL_DEAL_SINGLE_RECEIVED,
  COMMERCIAL_DEAL_SINGLE_REQUEST,
  COMMERCIAL_DEAL_SINGLE_UNLOAD,
} from "../reducers/types";
import * as ROUTES from "../../Router/corporate_routes";
import axios from "axios";
import qs from "query-string";
import handleErrors from "./utils";
import { publicEventCreated, publicEventCreatedError } from "./events";
import { removeEmptySearchParams } from "../../utils";

export const commercialDealRequest = () => ({
  type: COMMERCIAL_DEAL_LIST_REQUEST,
});

export const commercialDealReceivedRequest = data => ({
  type: COMMERCIAL_DEAL_LIST_RECEIVED,
  data,
});

export const commercialDealReceivedError = error => ({
  type: COMMERCIAL_DEAL_LIST_ERROR,
  error,
});

export const unloadCommercialDeals = () => ({
  type: COMMERCIAL_DEAL_LIST_UNLOAD,
});

export const commercialDealSingleRequest = () => ({
  type: COMMERCIAL_DEAL_SINGLE_REQUEST,
});

export const commercialDealSingleReceivedRequest = data => ({
  type: COMMERCIAL_DEAL_SINGLE_RECEIVED,
  data,
});

export const commercialDealSingleReceivedError = error => ({
  type: COMMERCIAL_DEAL_SINGLE_ERROR,
  error,
});

export const unloadCommercialSingleDeals = () => ({
  type: COMMERCIAL_DEAL_SINGLE_UNLOAD,
});

export const fetchCommercialDeals = (token, queryParams = {}) => {
  queryParams = new URLSearchParams(queryParams);
  removeEmptySearchParams(queryParams);
  let queryString = queryParams.toString();
  return dispatch => {
    dispatch(commercialDealRequest());
    return axios
      .get(window.API + ROUTES.API.COMMERCIAL_DEALS.LIST + "?" + queryString, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => dispatch(commercialDealReceivedRequest(response.data)))
      .catch(error => dispatch(commercialDealReceivedError(error)));
  };
};

export const fetchCommercialDeal = (token, id) => {
  return dispatch => {
    dispatch(commercialDealSingleRequest());
    return axios
      .get(window.API + ROUTES.API.COMMERCIAL_DEALS.SINGLE.replace(":id", id), {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response =>
        dispatch(commercialDealSingleReceivedRequest(response.data))
      )
      .catch(error => dispatch(commercialDealSingleReceivedError(error)));
  };
};

export const fetchCommercialDealsForVenue = (token, venue, enquiry) => {
  return dispatch => {
    dispatch(commercialDealRequest());
    return axios
      .get(
        window.API +
          ROUTES.API.COMMERCIAL_DEALS.FOR_VENUE.replace(
            ":venue",
            venue
          ).replace(":enquiry", enquiry),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(response => dispatch(commercialDealReceivedRequest(response.data)))
      .catch(error => dispatch(commercialDealReceivedError(error)));
  };
};

export const fetchCommercialDealForProposal = (token, proposalId) => {
  return dispatch => {
    dispatch(commercialDealSingleRequest());
    return axios
      .get(
        window.API +
          ROUTES.API.COMMERCIAL_DEALS.FOR_PROPOSAL.replace(
            ":proposal",
            proposalId
          ),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(response =>
        dispatch(commercialDealSingleReceivedRequest(response.data))
      )
      .catch(error => dispatch(commercialDealSingleReceivedError(error)));
  };
};

export const createCommercialDeal = (token, values) => {
  return dispatch => {
    dispatch(commercialDealSingleRequest());
    return axios
      .post(window.API + ROUTES.API.COMMERCIAL_DEALS.CREATE, values, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => {
        dispatch(commercialDealSingleReceivedRequest(response.data));
      })
      .catch(error => {
        dispatch(commercialDealSingleReceivedError(error));
        handleErrors(error);
      });
  };
};

export const editCommercialDeal = (commercialDeal, token, values) => {
  return dispatch => {
    dispatch(commercialDealSingleRequest());
    return axios
      .post(
        window.API +
          ROUTES.API.COMMERCIAL_DEALS.EDIT.replace(":deal", commercialDeal.id),
        values,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(response => {
        dispatch(commercialDealSingleReceivedRequest(response.data));
      })
      .catch(error => {
        dispatch(commercialDealSingleReceivedError(error));
        handleErrors(error);
      });
  };
};
